import React from "react";
import { useNavigate } from "react-router-dom";
import TrackingLinkItem from "../TrackingLinkItem/TrakingLinkItem";
import "./index.less";

export type TrackingLinkItem = {
  id: string;
  title: string;
  createdAt?: string;
  totalNumberOfClicks?: number;
  status?: string;
};

export type TrackingLinksListProps = {
  items: TrackingLinkItem[];
  listRef?: React.RefObject<HTMLDivElement | null>;
  pickerMode?: boolean;
};

const TrackingLinksList: React.FC<TrackingLinksListProps> = ({ items, listRef, pickerMode = false }) => {
  const navigate = useNavigate();

  return (
    <div className="tracking-link-list-card">
      <div className="tracking-link-list" role="list" ref={listRef as unknown as React.RefObject<HTMLDivElement>}>
        {items?.map((it, idx) => (
          <React.Fragment key={it.id}>
            <div className="tracking-link-list-item" role="listitem">
              <TrackingLinkItem
                title={it.title}
                createdAt={it.createdAt}
                nbrOfClicks={it.totalNumberOfClicks}
                onClick={() => navigate(`/creator/tracking-links/${it.id}`)}
              />
            </div>
            {pickerMode && idx < items?.length - 1 && <div className="tracking-link-list-divider" aria-hidden="true" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TrackingLinksList;
